import {Component, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ReportService} from '../../../services/report.service';
import {ReportInfoDTO} from '../../../model/reportInfoDTO';
import {Location} from '@angular/common';

@Component({
  templateUrl: './other-transaction-list-wrapper.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})

export class OtherTransactionListWrapperComponent implements OnInit {

  reportInfo: ReportInfoDTO;
  reportName: string;

  constructor(
    private route: ActivatedRoute,
    private service: ReportService,
    public location: Location) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.service.getInfo(params['reportId']).subscribe(info => {
        this.reportInfo = info;
        this.reportName = this.service.getReportName(this.reportInfo.type) +
          (this.reportInfo.year != null ? ' ' + this.reportInfo.year : '');
      });
    });
  }
}
